import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import {
    selectAll,
    TABLET_LANDSCAPE,
    getRightGutter,
    equalizeSlidesHeight,
    resetSwiperInlineHeights,
    attachImageLoadEqualizer,
    debounce,
} from '../simplerToolkit.js';

document.addEventListener('DOMContentLoaded', () => {
    const swipers = selectAll('section.testimonials .swiper');
    if (!swipers || !swipers.length) return;

    const baseBreakpoints = {
        650: {slidesPerView: 2.25, spaceBetween: 16},
        768: {slidesPerView: 2.25, spaceBetween: 20},
        1024: {slidesPerView: 4, spaceBetween: 24},
    };

    const registry = [];

    swipers.forEach((el) => {
        const instance = new Swiper(el, {
            modules: [Pagination],
            slidesPerView: 1.25,
            spaceBetween: 16,
            watchOverflow: true,
            breakpoints: baseBreakpoints,
            slidesOffsetAfter: window.innerWidth < TABLET_LANDSCAPE ? getRightGutter(el) : 0,
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
        registry.push({el, instance});

        const runEq = () => {
            requestAnimationFrame(() => {
                resetSwiperInlineHeights(el);
                equalizeSlidesHeight(el);
                if (instance.update) instance.update();
            });
        };
        instance.on && instance.on('init', runEq);
        instance.on && instance.on('breakpoint', runEq);
        runEq();
        attachImageLoadEqualizer(el, runEq);
    });

    window.addEventListener('resize', debounce(() => {
        registry.forEach(({el, instance}) => {
            instance.params.slidesOffsetAfter = window.innerWidth < TABLET_LANDSCAPE ? getRightGutter(el) : 0;
            resetSwiperInlineHeights(el);
            equalizeSlidesHeight(el);
            instance.update();
        });
    }));
});
